import {defineStore} from 'pinia'
import {deepClone, getUrlParams} from 'xmgoing-utils';
import {defSpaceDomainObj} from "@/module/pcSpace/IPcSpaceDomain";
import i18n from '@/i18n';
import {PageEnum} from "@/enums/pageEnum";
import GoingUtils from "@/utils/goingUtils";
import {getPcSpaceByAppId,getCurUserSpace} from "@/api/sys/portalSpace";
import {changeDbObjToSpaceObj} from "@/hooks/layouts/useSpaceHook";
import {StorageUtils} from 'xmgoing-utils';

/**
 * 从记录集合中获取一条对应的数据
 * @param selId
 * @param dataSource
 */
function getRecordById(selId:string,dataSource:any){
  const {innerApiList,connectionList} = dataSource;
  let sonItems=innerApiList.filter((itemObj:any)=>{
    return itemObj.id===selId;
  })
  //如果是内部函数
  if(sonItems.length>0){
    return sonItems[0];
  }
  //如果不是内部函数 则就是集成服务
  sonItems=connectionList.filter((itemObj:any)=>{
    return itemObj.id===selId;
  })
  if(sonItems.length>0){
    return sonItems[0];
  }
}

/**
 * 获取当前需要激活的空间对象
 * @param spaceList
 */
function getCurActiveObj(spaceList){
  let firstSpaceObj: any = null;
  const curKey=StorageUtils.getSessionItem(StorageUtils.getSessionItem('userId')+"_curSelSpaceItem");
  if(curKey){
    firstSpaceObj=spaceList.filter((itemDb)=>{
      return itemDb.id===curKey;
    })[0];
    if(firstSpaceObj==null){
      firstSpaceObj=spaceList[0];
    }
  }else{
    firstSpaceObj=spaceList[0];
  }
  return firstSpaceObj;
}

export const usePcSpaceStore = defineStore('pcSpaceStore', {
  state: () => {
    return {
      loadingFlag:true,
      appSpaceList:[],//子应用空间记录列表
      appCurSpaceItem:null,//子应用的空间记录
      curSpaceItem:null,//主应用空间记录
      dataSourceList:{},
      pcSpaceList:[],//主应用的空间列表
      pageType:'showPage',
      pcSpaceObj: deepClone(defSpaceDomainObj),
      dataSource: {backFunList: [], innerApiList: [], connectionList: []}
    }
  },
  // 也可以这样定义状态
  // state: () => ({ count: 0 })
  getters: {
    getPcSpaceList(){
      return this.pcSpaceList;
    }
  },
  actions: {
    setLoadingFlag(flag){
       this.loadingFlag=flag
    },
    /**
     * 设置子应用的空间记录
     * @param curSpaceItem
     */
    setCurAppSpaceItem(curSpaceItem:any){
      this.appCurSpaceItem=curSpaceItem;
    },
    //设置当前空间对象
    setCurSpaceItem(curSpaceItem:any){
      this.curSpaceItem=curSpaceItem;
    },
    /**
     * 获取应用的空间列表 不需要授权
     * @param appId
     */
    async getPcSpaceByAppIdAction(appId:string,dataSourceStore?:any){
      let spaceList:Array<any>=[];
      spaceList =await getPcSpaceByAppId(appId);
      this.appSpaceList=spaceList;
      this.loadingFlag=false;
      //设置当前默认选择第一条
      if (spaceList && spaceList.length > 0) {
        let firstSpaceObj=getCurActiveObj(spaceList);

        if (firstSpaceObj) {
          firstSpaceObj=changeDbObjToSpaceObj(firstSpaceObj,dataSourceStore);
          //存入store
          this.setPcSpaceObj(firstSpaceObj);
          this.setCurAppSpaceItem(firstSpaceObj);
        }
      }
    },
    /**
     * 获取子应用对应的空间记录
     * @param appId
     */
    async getAppSpaceItemsAction(appId:string,dataSourceStore,showType='analysisSet'){
      let spaceList:Array<any>=[];
      spaceList =await getCurUserSpace(appId);
      this.appSpaceList=spaceList;
      this.loadingFlag=false;
      //设置当前默认选择第一条
      if (spaceList && spaceList.length > 0) {
        let firstSpaceObj=getCurActiveObj(spaceList);
        if (firstSpaceObj) {
          firstSpaceObj=changeDbObjToSpaceObj(firstSpaceObj,dataSourceStore);
          //存入store
          this.setPcSpaceObj(firstSpaceObj);
          this.setCurAppSpaceItem(firstSpaceObj);
        }
      }
    },
    /**
     * 获取主应用的空间列表信息集合
     */
    async getSpaceItemsAction(dataSourceStore,pageModelsStore,showType='analysisSet'){
      let spaceList:Array<any>=[];
      if(this.pcSpaceList&&this.pcSpaceList.length===0){
        spaceList =await getCurUserSpace();
        this.pcSpaceList=spaceList;
        this.loadingFlag=false;
        //设置当前默认选择第一条
        if (spaceList && spaceList.length > 0) {
          let firstSpaceObj=getCurActiveObj(spaceList);
          if (firstSpaceObj) {
            firstSpaceObj=changeDbObjToSpaceObj(firstSpaceObj,dataSourceStore);
            //存入store
            dataSourceStore.setDataSourceList(firstSpaceObj.dataSourceConfig,pageModelsStore);
            this.setPcSpaceObj(firstSpaceObj);
            this.setCurSpaceItem(firstSpaceObj);
          }
        }
      }
      setTimeout(()=>{
        this.loadingFlag=false;
      },2000)
    },
    //设置界面类型 分预览界面和设计界面2种类型
    setPageType(pageType){
      this.pageType=pageType;
    },
    initModuleApiState(apiList: Array<any>) {
      apiList.forEach((itemObj) => {
        const list = this.dataSource.innerApiList.filter((itemObjDb: any) => {
          return itemObjDb.id === itemObj.id;
        })
        if (list.length === 0) {
          itemObj.checked = false;
        } else {
          itemObj.checked = true;
        }
      })
    },
    /***
     * 设置栏目空间信息
     * @param pcSpaceObj
     */
    setPcSpaceObj(pcSpaceObj) {
      if(getUrlParams("type",true)===PageEnum.COMMON_PAGE){
        this.pcSpaceObj = {...pcSpaceObj};
        this.pcSpaceObj.code=getUrlParams("curPageId",true)+"";
        this.pcSpaceObj.name=getUrlParams("curPageName",true)+"";
      }else{
        this.pcSpaceObj = {...deepClone(defSpaceDomainObj),...pcSpaceObj};
      }
    },
    initDataSource(){

    },
    /**
     * 设置空间的rows
     * @param rows
     */
    setPcSpaceObjRows(rows: Array<any>) {
      const oldObj=deepClone(this.pcSpaceObj);
      this.pcSpaceObj={...deepClone(defSpaceDomainObj),...oldObj};
      this.pcSpaceObj['rows'] = rows;
    },
  },
})
